import gql from 'graphql-tag';

export const optionFragment = gql`
  fragment OptionFields on Option {
    id
    name
    imageUrl
    posPrice
    posInfo {
      externalId
      overridedFields
    }
  }
`;

export const menuOptionFragment = gql`
  fragment MenuOptionFields on MenuOption {
    id
    enabled
    price
    option {
      ...OptionFields
    }
  }

  ${optionFragment}
`;

export const editorConfigFragment = gql`
  fragment EditorOptionConfigFields on EditorOptionConfig {
    defaultOptions {
      ...MenuOptionFields
    }
    addText
    sorter
    widget
    editText
    disabledRows
    canTurnOff
    allowCustom
  }

  ${menuOptionFragment}
`;

export const optionGroupFragment = gql`
  fragment MenuOptionGroupFields on MenuOptionGroup {
    id
    name
    editorConfig {
      ...EditorOptionConfigFields
    }
    menuOptions {
      ...MenuOptionFields
    }
  }

  ${editorConfigFragment}
  ${menuOptionFragment}
`;
